/**
 * Single source list for the UI Test Navigator (dev/staging only).
 * When you add a new UI test/preview route in testRoutes.jsx, also add it here
 * with a clear page name so it shows up in the navigator search.
 */

function entry(name, path, category, keywords = []) {
  return { name, path, category, keywords }
}

export const UI_TEST_NAVIGATOR_ROUTES = [
  // Auth / account
  entry('School Admin Test Index', '/test/school-admin', 'Auth', [
    'index',
    'hub'
  ]),
  entry('Login', '/test/login', 'Auth', ['signin', 'welcome']),
  entry('Register (responsive)', '/test/register', 'Auth', [
    'signup',
    'create account'
  ]),
  entry('Register (desktop)', '/test/register?layout=desktop', 'Auth', [
    'signup',
    'desktop'
  ]),
  entry('Register (mobile)', '/test/register?layout=mobile', 'Auth', [
    'signup',
    'mobile'
  ]),
  entry('Forgot Password', '/test/forgot-password', 'Auth', [
    'reset',
    'password'
  ]),
  entry(
    'Forgot Password — OTP (username known)',
    '/test/forgot-password?screen=otp-with-username',
    'Auth',
    ['otp', 'student']
  ),
  entry(
    'Forgot Password — OTP (enter username)',
    '/test/forgot-password?screen=otp-manual',
    'Auth',
    ['otp']
  ),
  entry(
    'Forgot Password — Reset form',
    '/test/forgot-password?screen=reset-form',
    'Auth',
    ['reset']
  ),
  entry(
    'Forgot Password — Invalid link',
    '/test/forgot-password?screen=reset-invalid',
    'Auth',
    ['expired']
  ),
  entry(
    'Forgot Password — Validating',
    '/test/forgot-password?screen=reset-validating',
    'Auth',
    ['loading']
  ),
  entry('Email Verification OTP', '/test/email-verification-otp', 'Auth', [
    'verify',
    'otp'
  ]),
  entry(
    'School Admin — Register',
    '/test/school-admin/register',
    'School Admin'
  ),
  entry(
    'School Admin — Verify Email',
    '/test/school-admin/verify-email',
    'School Admin'
  ),
  entry(
    'School Admin — Account Setup',
    '/test/school-admin/account-setup',
    'School Admin'
  ),
  entry(
    'School Admin — Plan Options',
    '/test/school-admin/plan-options',
    'School Admin'
  ),
  entry(
    'School Admin — Payment Success',
    '/test/school-admin/payment-success',
    'School Admin'
  ),
  entry(
    'School Admin — Onboarding School Details',
    '/test/school-admin/onboarding-school-details',
    'School Admin'
  ),
  entry(
    'School Admin — Invite Teachers',
    '/test/school-admin/onboarding-invite-teachers',
    'School Admin'
  ),
  entry(
    'School Admin — Teacher Invite Accept',
    '/test/school-admin/teacher-invite-accept',
    'School Admin'
  ),
  entry(
    'School Admin — School Users',
    '/test/school-admin/school-users',
    'School Admin'
  ),
  entry(
    'School Admin — Dashboard',
    '/test/school-admin/dashboard',
    'School Admin'
  ),
  entry(
    'School Admin — School Details',
    '/test/school-admin/school-details',
    'School Admin'
  ),
  entry(
    'School Admin — Classrooms',
    '/test/school-admin/classrooms',
    'School Admin'
  ),
  entry('School Admin — Lessons', '/test/school-admin/lessons', 'School Admin'),
  entry('School Admin — Profile', '/test/school-admin/profile', 'School Admin'),
  entry('School Admin — Billing', '/test/school-admin/billing', 'School Admin'),

  // Shared / board / student
  entry('Shared — Contact Support', '/test/shared/contact', 'Shared'),
  entry('Shared — Help Center', '/test/shared/help', 'Shared'),
  entry('Board Dashboard', '/test/board', 'Shared', ['board']),
  entry(
    'Student Leaderboard Test',
    '/test/student-leaderboard',
    'Shared',
    ['leaderboard']
  ),
  entry('Parent Plan Options', '/test/parent-plan-options', 'Shared', [
    'plans'
  ]),
  entry('Educator LP', '/test/educator-lp', 'Shared', ['landing']),

  // Mission chrome
  entry(
    'Mission Rewards Summary',
    '/test/mission-rewards-summary',
    'Mission UI'
  ),
  entry('Mission Ending', '/test/mission-ending', 'Mission UI'),
  entry('Mission Loading', '/test/mission-loading', 'Mission UI'),

  // Games
  entry('Flip Card Game', '/test/flip-card-game', 'Games'),
  entry('Consent Game', '/test/consent-game', 'Games'),
  entry('Animal Zoo Game', '/test/animal-zoo-game', 'Games'),
  entry('Car Race Game', '/test/car-race-game', 'Games'),
  entry('Chat Moderator Game', '/test/chat-moderator-game', 'Games'),
  entry('Pacman Game', '/test/pacman-game', 'Games'),
  entry('Symptom Sorter', '/test/symptom-sorter', 'Games'),
  entry('How You React', '/test/how-you-react', 'Games'),
  entry('MFA Game', '/test/mfa', 'Games'),
  entry('Digital Footprint Game', '/test/digital-footprint', 'Games'),
  entry('IP Address Game', '/test/ip-address-game', 'Games'),
  entry('Out Smart', '/test/out-smart', 'Games'),
  entry('Ghost Hunt', '/test/ghost-hunt', 'Games'),
  entry('Password Inspector', '/test/password-inspector', 'Games'),

  // Mission actions
  entry('Spider Move', '/test/spider-move', 'Actions'),
  entry('Cyber Definition', '/test/cyber-definition', 'Actions'),
  entry('Trusted Adults', '/test/trusted-adults', 'Actions'),
  entry('Backpack', '/test/backpack', 'Actions'),
  entry('Footprint Video', '/test/footprint-video', 'Actions'),
  entry('Luna Post', '/test/luna-post', 'Actions'),
  entry('Milo Post', '/test/milo-post', 'Actions'),
  entry('Post Book', '/test/post-book', 'Actions'),
  entry('Tshirt', '/test/tshirt', 'Actions'),
  entry('Puzzle Drop', '/test/puzzle-drop', 'Actions'),
  entry('Plush Toy', '/test/plush-toy', 'Actions'),
  entry('Smart Goggle', '/test/smart-goggle', 'Actions'),
  entry('IP Address Scrap', '/test/ip-address-scrap', 'Actions'),
  entry('Search Warrant', '/test/search-warrant', 'Actions'),
  entry('Phone Call', '/test/phone-call', 'Actions'),
  entry('Receive Phone Call', '/test/receive-phone-call', 'Actions'),
  entry('Snappy Pal', '/test/snappy-pal', 'Actions'),
  entry('Snappy Pal Map', '/test/snappy-pal-map', 'Actions'),
  entry('Apply Uni', '/test/apply-uni', 'Actions'),
  entry('Image Popup', '/test/image-popup', 'Actions'),
  entry('Save Password', '/test/save-password', 'Actions'),
  entry('Image Sound', '/test/image-sound', 'Actions'),
  entry('Phone Code', '/test/phone-code', 'Actions'),
  entry('Thumb Scan', '/test/thumb-scan', 'Actions'),
  entry('Speaker Volume', '/test/speaker-volume', 'Actions'),
  entry('What You See', '/test/what-you-see', 'Actions'),
  entry('Danger Alert', '/test/danger-alert', 'Actions'),
  entry('Phone Message', '/test/phone-message', 'Actions'),
  entry('Book Page', '/test/book-page', 'Actions'),
  entry('Paparazzi', '/test/paparazzi', 'Actions'),
  entry('Should You Post', '/test/should-you-post', 'Actions'),
  entry('Letter Popup', '/test/letter-popup', 'Actions'),
  entry('Play Narration', '/test/play-narration', 'Actions'),
  entry('Play Only Narration', '/test/play-only-narration', 'Actions'),
  entry('Bug Scream', '/test/bug-scream', 'Actions'),
  entry('Astra Backpack', '/test/astra-backpack', 'Actions'),
  entry('Webcam', '/test/webcam', 'Actions'),
  entry('Not Put On Internet', '/test/not-put-on-internet', 'Actions'),
  entry('Scene Intro', '/test/scene-intro', 'Actions'),
  entry('Empty Action', '/test/empty-action', 'Actions')
]

export const UI_TEST_NAVIGATOR_CATEGORIES = [
  'Auth',
  'School Admin',
  'Shared',
  'Mission UI',
  'Games',
  'Actions'
]

export function filterUiTestNavigatorRoutes(query) {
  const q = String(query || '')
    .trim()
    .toLowerCase()
  if (!q) return UI_TEST_NAVIGATOR_ROUTES

  return UI_TEST_NAVIGATOR_ROUTES.filter((route) => {
    const haystack = [
      route.name,
      route.path,
      route.category,
      ...(route.keywords || [])
    ]
      .join(' ')
      .toLowerCase()
    return haystack.includes(q)
  })
}
